export default __webpack_public_path__ + "static/26-4ab239de0d16d9737eb97cf3afcd67a6.webp";